import { logger } from "@/logging";
import { Component, ReactNode } from "react";

/** Compact error boundary for individual components */
export class CompactErrorBoundary extends Component<{ name: string; children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logger.error('Component', `${this.props.name}: ${error.message}\n${error.stack}\n${errorInfo.componentStack}`);
  }
  render() {
    if (this.state.error) {
      return <div style={{ color: '#f87171', fontSize: 10, padding: 4 }}>Error: {this.state.error.message}</div>;
    }
    return this.props.children;
  }
}
